import * as glide from "@glide/plugins";
import ms from "ms";
import type { StringValue } from "ms";

export const waitDurationParameter = glide.makeParameter({
    type: "string",
    name: "Wait duration",
    description: "The length of time to wait for a human to use the link. Maximum of 7 days. English expressions like 8 hours or 3 days are supported.",
    defaultValue: "8 hours",
    placeholder: "8 hours",
});

export function parseWaitDuration(waitDuration: string | undefined) {
    waitDuration = (waitDuration ?? "8 hours").trim();
    if (/^\d+$/.test(waitDuration)) {
        waitDuration += " hours";
    }

    const waitDurationMS = ms(waitDuration as StringValue);
    if (waitDurationMS === undefined) {
        return glide.Result.Fail(`Invalid wait duration: ${waitDuration}`);
    }
    if (waitDurationMS <= 10 * 1000) {
        return glide.Result.Fail("Wait duration must be at least 10 seconds");
    }
    // NOTE: If this limit is raised, the corresponding `maxSignalTimeoutMS` limit in the
    // Automations service may also need raising.
    if (waitDurationMS > 7 * 24 * 60 * 60 * 1000) {
        return glide.Result.Fail("Wait duration must be less than 7 days");
    }

    return glide.Result.Ok(waitDurationMS);
}
